import { React, models, kea, history, resources, selectores, componentToRx, Route, match, withRouter } from "app/main/std";
import { UsuarioApiForm } from "./form";
import { observeResource } from "kea-resource";
type Entity = models.UsuarioApi;
const resource = resources.UsuarioApi;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}
class UsuarioApiEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue()};
    }

    get id() : number | "new" {
        const id = this.props.match.params.id;
        return id == "new" ? id : Number.parseInt(id);
    }

    async getValue() {
        if (this.id == "new") {
            return {
            } as Entity;
        } else {
            return await resource.get(this.id);
        }
    }

    onChange = (value: Entity) => this.setState({value});
    onGuardar = async () => {
        const id = this.id;
        const func = id == "new" ? resource.add : resource.update;
        const value = await this.state.value;
        await func(value);
        history.go("/catalogos/UsuarioApi");
    }

    render() {
        const props = this.props;
        const params = props.match!.params.id;

        return (
            <UsuarioApiForm 
                value={this.state.value}
                onChange={this.onChange}
                onGuardar={this.onGuardar}
                nuevo={this.id == "new"}
            />
        );
    }
}

export const UsuarioApiEdit = withRouter(UsuarioApiEditComp);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuarioApi/edit/index.tsx